<template>
  <BaseAction>
    <SecondaryButton
      :loading="downloading"
      @click.native="downloadFile"
      textColor="#0965dc"
    >
      <v-icon>
        mdi-content-copy
      </v-icon>
      Download
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { getToken } from "@/services/utils";
import APIService from "@/services/APIService";
import { first, size } from "lodash";
import { fileToDownload } from "@/utils/helpers";

export default {
  props: {
    applicationsIds: Array
  },
  components: {
    BaseAction,
    SecondaryButton
  },
  data() {
    return {
      downloading: false
    };
  },
  computed: {
    isMultiple() {
      return size(this.applicationsIds) > 1;
    }
  },
  methods: {
    async downloadFile() {
      const token = `token=${getToken()}`;
      const file = { fileName: "applications.pdf" };
      const ids = this.applicationsIds;
      const isBuffer = ids.length <= 20;
      file.url = this.isMultiple
        ? `${APIService.host}/applications/download/?${token}`
        : `${APIService.host}/applications/${first(
            this.applicationsIds
          )}/download/?${token}`;
      this.downloading = true;
      await fileToDownload(file, this.isMultiple ? { ids } : null, isBuffer);
      this.downloading = false;
    }
  }
};
</script>
